import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header>
      <div className="d-flex justify-content-between align-items-center p-4">
        <div className="logo">
          <Link to="/">
            <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="logo" />
          </Link>
        </div>
        <div className="privacy-policy fw-bold regular-font">
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
